module.exports = {
      id: "shortvideo-usage",
      viewBox: "0 0 15 19",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#shortvideo",
      toString: function () {
        return this.url;
      }
    }